import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CheckoutSurcharge, CheckoutSurchargePayload } from "src/app/models/enrollment-checkout";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-surcharge',
    templateUrl: './surcharge.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutSurchargeComponent implements OnInit {
    @Input() public checkoutSurcharge: CheckoutSurcharge;

    @Output() public emitComplete: EventEmitter<CheckoutSurchargePayload> = new EventEmitter();

    public surchargeForm: FormGroup;
    constructor(
        private formBuilder: FormBuilder,
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        this.surchargeForm = this.formBuilder.group({
            coverageDetailID: [null, Validators.required]
        });
    }

    public complete(): void {
        const l_CheckoutSurchargePayload = this.helperService.convertFormGroupIntoObject(this.surchargeForm, new CheckoutSurchargePayload());
        this.emitComplete.emit(l_CheckoutSurchargePayload);
    }
}